import React, {useState} from 'react';
import {Button, Dialog, DialogContent, FormControl, FormHelperText} from '@mui/material';
import {v4 as uuidv4} from 'uuid';
import {api} from "../../../utils/http";
import { uploadApplicantDocument } from "../../../utils/uploadDocument";
import {
  addFirstSitting,
  addSecondSitting,
  addUploads
} from "../../../redux/reducers/features/applicant-data/ssce-info-slice";
import {toast} from "react-toastify";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {ColorRing} from "react-loader-spinner";


function DirectTransferPayment({applicantData}) {
  const [file, setFile] = useState(null);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const uid = Math.floor(1000000000 + Math.random() * 9000000000);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleClick = () => {
    document.getElementById('file-input').click();
  };

  const updateApplicantData = async () => {
    if (!file) {
      toast.error('Please select a payment proof file');
      return;
    }

    if (!applicantData?._id) {
      toast.error('Applicant record not found. Please restart the application.');
      return;
    }

    setLoader(true);

    try {
      const uploadPayload = await uploadApplicantDocument(file, 'proof_of_payment');

      if (!uploadPayload?.file_url) {
        toast.error('Unable to upload payment proof. Please try again.');
        return;
      }

      const applicantRegistration = await api.patch(`/api/applicant/${applicantData._id}`, {
        transaction_ref: uid,
        paymentType: 'direct_transfer_payment',
        paymentFile: {...uploadPayload, amount: 500000},
      });

      if (applicantRegistration?.success) {
        localStorage.setItem('applicant_id', applicantRegistration.data._id);
        dispatch(addUploads([...(applicantRegistration.data?.documents || [])]));
        dispatch(addFirstSitting(applicantRegistration.data?.exam_first_sitting));
        dispatch(addSecondSitting(applicantRegistration.data?.exam_second_sitting));

        toast.success('Applicant Registration was successful');

        const applicationType = JSON.parse(localStorage.getItem('applicationType'));

        switch (applicationType) {
          case 'JAMB_ENTRY':
            navigate('/jamb-application-summary');
            break;
          case 'IJMB_ENTRY':
            navigate('/ijmb-application-summary');
            break;
          default:
            navigate('/direct-entry-application-summary');
            break;
        }
      } else {
        toast.error(
          applicantRegistration?.message || 'Applicant Registration was not successful'
        );
      }
    } catch (error) {
      toast.error(error?.message || 'Unable to submit payment proof');
    } finally {
      setLoader(false);
    }
  }


  return (
    <div style={{
      padding: '32px',
      backgroundColor: '#F2F9FF',
      border: 'solid 1px #00356B',
      textAlign: 'center',
      borderRadius: '10px',
    }}
    >
      {
        loader && (

          <Dialog
            open={loader}
            onClose={() => setLoader(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  margin: '0'
                }}>
                <ColorRing
                  visible={true}
                  height="30"
                  width="30"
                  ariaLabel="color-ring-loading"
                  wrapperStyle={{textAlign: 'center'}}
                  wrapperClass="color-ring-wrapper"
                  colors={['#00356B', '#00356B', '#00356B', '#00356B', '#00356B']}
                />
              </div>
            </DialogContent>
          </Dialog>
        )
      }

      <h3
        style={{
          fontSize: '24px',
          fontFamily: 'Inter',
          fontWeight: '500',
          lineHeight: '29px'
        }}
      >
        Make Direct Transfer
      </h3>

      <h6
        style={{
          fontWeight: '400',
          fontSize: '16px',
          fontFamily: 'Inter',
          lineHeight: '24px',
          color: '#2E5565'
        }}
      >
        You can transfer directly to the account below and submit your proof of payment
      </h6>

      <div>
        <h5
          style={{
            fontWeight: '400',
            fontSize: '16px',
            fontFamily: 'Inter',
            lineHeight: '24px',
            color: '#000000',
            marginBottom: '1rem'
          }}
        >
          Kindly pay into the account details below;
        </h5>

        <h4
          style={{
            fontWeight: '500',
            fontSize: '18px',
            fontFamily: 'Inter',
            lineHeight: '21px',
            color: '#00356b'
          }}
        >
          Peace Micro Finance Bank Ltd.
        </h4>

        <h4
          style={{
            fontWeight: '600',
            fontSize: '40px',
            fontFamily: 'Inter',
            lineHeight: '48px',
            color: '#00356b'
          }}
        >
          1100544852
        </h4>

        <h4
          style={{
            fontWeight: '400',
            fontSize: '18px',
            fontFamily: 'Inter',
            lineHeight: '27px',
            color: '#2E5565'
          }}
        >
          MU School fees
        </h4>

      </div>

      <div style={{margin: '2rem 0'}}>
        <h6>
          Upload Proof of Payment
        </h6>

        <FormControl>
          <Button variant="contained" color="primary" onClick={handleClick}>
            Choose File
          </Button>
          <input
            type="file"
            id="file-input"
            style={{display: 'none'}}
            onChange={handleFileChange}
          />
          <FormHelperText>
            {file ? `Selected file: ${file.name}` : 'No file selected'}
          </FormHelperText>
        </FormControl>

      </div>


      <Button
        variant="contained"
        color="primary"
        onClick={async () => await updateApplicantData()}
        sx={{width: '100%'}}
      >
        submit
      </Button>

    </div>
  );
}

export default DirectTransferPayment;
